// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "io.zelus",
    name: "Zelus",
    homepage: "https://zelus.io",
    image_id: "aeba2105-6c84-4642-f441-b3f5817ac400",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/zelus/id1588430343",
        android: "https://play.google.com/store/apps/details?id=com.zelus.wallet",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "zeluswallet://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map